export default {"src":"/_next/static/media/spiritory.6e393ea5.svg","height":1001,"width":1476,"blurWidth":0,"blurHeight":0};